import { create } from "zustand";
export var useFilterSectionSelectedChange = create(function(set, get) {
    return {
        version: 1,
        optionChanged: function(shouldMemoMillionLint) {
            if (shouldMemoMillionLint) {
                set({
                    version: get().version + 1
                });
            }
        }
    };
});
